// optics Watch image
import glass1 from "../images/glass1.webp";
import glass2 from "../images/glass2.webp";
import glass3 from "../images/glass3.webp";
import glass4 from "../images/glass4.webp";
import glass5 from "../images/glass5.webp";
import singleWatch from "../images/singleWatch.webp";
import simpleWatch from "../images/simple_watch.webp";
import watch1 from "../images/watch1.webp";
import watch2 from "../images/watch2.webp";
// optics Watch image

// opticsWatch brand image
import rayBan from "../images/ray-ban.webp";
import zeiss from "../images/zeiss.webp";
import occular from "../images/occular.webp";
import apple from "../images/apple.webp";
import titan from "../images/titan.webp";
// opticsWatch brand image

// opticsWatch shop image
import shop1 from "../images/shop1.webp";
import hatil from "../images/hatil.webp";
import steelcase from "../images/steelcase.webp";

export const opticsWatch = [
  {
    id: 20,
    cardImg: glass1,
    title: "police gray eyeglasses",
    prizeCurrent: "150.30",
    prizeClose: " $167.00",
    off: "10%",
    like: false,
  },
  {
    id: 21,
    cardImg: glass2,
    title: "say ban mutt black",
    prizeCurrent: "117.39",
    prizeClose: "$129.00",
    off: "9%",
    like: false,
  },
  {
    id: 22,
    cardImg: glass3,
    title: "say ban black",
    prizeCurrent: "156.24",
    prizeClose: "$168.00",
    off: "7%",
    like: false,
  },
  {
    id: 23,
    cardImg: glass4,
    title: "say ban ocean",
    prizeCurrent: "194.12",
    prizeClose: "$221.00",
    off: "8%",
    like: false,
  },
  {
    id: 24,
    cardImg: glass5,
    title: "sun glasses collection",
    prizeCurrent: "136.71",
    prizeClose: "$147.00",
    off: "7%",
    like: false,
  },
  {
    id: 25,
    cardImg: singleWatch,
    title: "ziaomi mi band2",
    prizeCurrent: "222.27",
    prizeClose: "$239.00",
    off: "7%",
    like: false,
  },
  {
    id: 26,
    cardImg: simpleWatch,
    title: "kossil watch brown",
    prizeCurrent: "244.72",
    prizeClose: "$266.00",
    off: "8%",
    like: false,
  },
  {
    id: 27,
    cardImg: watch1,
    title: "MVMTM watch black",
    prizeCurrent: "199.28",
    prizeClose: "$212.00",
    off: "6%",
    like: false,
  },
  {
    id: 28,
    cardImg: watch2,
    title: "xarioho watch black",
    prizeCurrent: "214.70",
    prizeClose: "$226.00",
    off: "5%",
    like: false,
  },
];

export const opticsWatchBrand = [
  {
    img: rayBan,
    text: "Ray-Ban",
  },
  {
    img: zeiss,
    text: "Zeiss",
  },
  {
    img: occular,
    text: "Occular",
  },
  {
    img: apple,
    text: "Apple",
  },
  {
    img: titan,
    text: "Titan",
  },
];
export const opticsWatchShop = [
  {
    img: shop1,
    text: "Scarelett",
  },
  {
    img: zeiss,
    text: "Scroll Through",
  },
  {
    img: hatil,
    text: "Coveted Clicks",
  },
  {
    img: steelcase,
    text: "Constant Shoppers",
  },
];
